// extracted by mini-css-extract-plugin
module.exports = {"addNewRow":"Scores-module__addNewRow___35jnT","cards":"Scores-module__cards___19Yxo","header":"Scores-module__header___2Z8HS"};